import type { IErrorInfo, IErrorDetails } from '../errors';
import { errorInfoSchema } from '../errors';
import { errorInfo } from './errorInfo';
import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const ERROR = 'APPS/ERROR';

export const errorActionSchema = objectSchemaOf<IErrorAction>({
  type: Joi.string().required().valid(ERROR),
  payload: errorInfoSchema,
});

export interface IErrorAction {
  type: typeof ERROR;
  payload: IErrorInfo;
}

export const error = actionCreator({
  type: ERROR,
  schema: errorActionSchema,
  creator: (
    incomingError: Error | unknown,
    details?: IErrorDetails
  ): IErrorAction => ({
    type: ERROR,
    payload: errorInfo(incomingError, details),
  }),
});
